export class BaseEntity {
	Id: number | any;
}
